import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./Modal.css";
import { buildDocument } from "../../CommonWeb/Common";

const HTMLReader = (props) => {
  const { show, onPlaceMenuLink } = props;
  // Only the Modal's own props go on to it — the rest are this reader's
  // (paging, place-menu link, content), which react-bootstrap would put on
  // a plain <div> ("Unknown event handler property", "React does not
  // recognize the `showPaging` prop" warnings, 2026-10-18).
  // eslint-disable-next-line no-unused-vars
  const { onPlaceMenuLink: _pm, showPaging: _sp, canGoPrevious: _cp, canGoNext: _cn, onPrevious: _op, onNext: _on, compact: _c, html: _h, title: _t, ...modalProps } = props;
  // buildDocument's injected script forwards every non-http(s) link click to
  // window.customLink (see CommonWeb/Common.js) — but unlike Home.js/
  // HomeContent.js, this LOCAL dialog never defined that function itself, so
  // a "Place Menu" link (placemenulink:<id>, added to createPlaceDetailsHTML
  // 2026-10-06) silently did nothing when shown here (e.g. PlaceCard.js's
  // "i" icon, Map.js's attributes branch, PlaceModal.js's own HTMLReaderModal
  // — anywhere this dialog is used instead of the Home-tab push). Callers
  // that want it handled pass onPlaceMenuLink; this restores whatever
  // customLink was previously set on hide/unmount, unlike Home.js/
  // HomeContent.js's own unconditional overwrite-with-no-cleanup. Other link
  // types typed into place/event notes aren't handled here — same
  // pre-existing gap as before this change, out of scope. Found 2026-10-06.
  useEffect(() => {
    if (!show) return undefined;
    const previous = window.customLink;
    window.customLink = (url) => {
      // urlSchemeToFunctions (CommonWeb/Common.js) rewrites "scheme:id" to an
      // onclick="customLink('scheme;id')" handler (first colon -> semicolon)
      // before this ever reaches here — Home.js's own customLink mirrors
      // this exact normalization (url_prop.replace(";", ":")) before
      // parsing. Missing it here meant url.startsWith("placemenulink:")
      // never matched the actual semicolon-separated value, so the link
      // silently fell through to `previous` (often undefined) and did
      // nothing. Found 2026-10-06 — reported as "place menu does not
      // display" in mobile mode.
      const normalized = typeof url === "string" ? url.replace(";", ":") : url;
      if (typeof normalized === "string" && normalized.startsWith("placemenulink:") && onPlaceMenuLink) {
        onPlaceMenuLink(normalized.slice("placemenulink:".length));
        return;
      }
      if (typeof previous === "function") previous(url);
    };
    return () => { window.customLink = previous; };
  }, [show, onPlaceMenuLink]);

  //console.log("HTMLReader", props);
  let title = "Andiamo Places";
  if(props.title !== "undefined") title = props.title
  // "lg" + a 60vh floor made sense for long HTML pages, but for small fixed-
  // size content (e.g. a 448x336 video) it left a lot of dead white space
  // around/below it in mobile mode's narrower layout. Desktop keeps the old
  // sizing since it wasn't reported there. Fixed 2026-09-12.
  let MobileMode = useSelector((state) => state.MobileMode);
  // Small fixed-size content (e.g. a video) doesn't need the "lg" modal or a
  // thick header — those made the dialog cover more of the map/place behind
  // it than the content itself needed. Callers opt in via props.compact.
  const compact = props.compact === true;

  // let HTMLToSHow = useSelector((state) => state.HTMLToSHow);
  // let HTMLStack = useSelector((state) => state.HTMLStack);
  // let HTMLTitle = useSelector((state) => state.HTMLTitle);
  //console.log("HTMLReader", HTMLStack.length);
  // const handleLeftArrow = () => {
  //console.log("handleLeftArrow", HTMLStack.length);
  //   if (HTMLStack.length <= 1) {
  //     dispatch(slice1Actions.clearHTMLStack());
  //     dispatch(slice1Actions.setShowHTMLReader({ value: false }));
  //     return;
  //   }
  //   const htmlString = HTMLStack[HTMLStack.length - 2];
  //   dispatch(slice1Actions.popHTMLStack());
  //   dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
  //   dispatch(slice1Actions.setShowHTMLReader({ value: true }));
  // };

  // const handleClose = () => {
  //   //console.log("handleClose", HTMLStack.length);
  //   dispatch(slice1Actions.setHTMLTitle({ value: "Content" }));
  //   dispatch(slice1Actions.clearHTMLStack());
  //   dispatch(slice1Actions.setShowHTMLReader({ value: false }));
  // };
  //console.log("HTMLReader", HTMLToSHow);
  return (
    <div className="html-reader-modal">
      <Modal {...modalProps} size={MobileMode || compact ? undefined : "lg"} aria-labelledby="contained-modal-title-vcenter" onHide={props.onHide}>
        <Modal.Header closeButton style={compact ? { padding: "0.35rem 0.75rem", minHeight: 0 } : undefined}>
          {props.showPaging ? (
            <button
              type="button"
              className="html-reader-page-btn"
              onClick={props.onPrevious}
              disabled={!props.canGoPrevious}
              aria-label="Previous place"
              style={{
                border: "none",
                background: "none",
                fontSize: "1.3rem",
                lineHeight: 1,
                padding: "0 0.5rem",
                opacity: props.canGoPrevious ? 1 : 0.3,
                cursor: props.canGoPrevious ? "pointer" : "default",
              }}
            >
              &#8249;
            </button>
          ) : null}
          <Modal.Title id="example-modal-sizes-title-sm" style={compact ? { fontSize: "0.95rem" } : undefined}>{title}</Modal.Title>
          {props.showPaging ? (
            <button
              type="button"
              className="html-reader-page-btn"
              onClick={props.onNext}
              disabled={!props.canGoNext}
              aria-label="Next place"
              style={{
                border: "none",
                background: "none",
                fontSize: "1.3rem",
                lineHeight: 1,
                padding: "0 0.5rem",
                marginRight: "0.5rem",
                opacity: props.canGoNext ? 1 : 0.3,
                cursor: props.canGoNext ? "pointer" : "default",
              }}
            >
              &#8250;
            </button>
          ) : null}
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          {props.show ? (
            <iframe
              title="Guide Content"
              srcDoc={buildDocument(props.html || "")}
              style={{ border: "none", width: "100%", display: "block", ...(MobileMode || compact ? {} : { minHeight: "60vh" }) }}
              onLoad={(e) => {
                const frame = e.target;
                if (frame.contentDocument) {
                  frame.style.height = frame.contentDocument.body.scrollHeight + "px";
                }
              }}
            />
          ) : null}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default HTMLReader;
